import React from "react";
import Container from "../Layout/Container";
import { connect } from "react-redux";
import {
  getSmsItems,
  postSmsItem,
  deleteSmsItem,
  updateSmsItem,
  clearErrors,
} from "../../redux/Actions/smsAction";
import SmsEditModal from "./Items/SmsEditModal";
import ContentBlock from "../Layout/ContentBlock";
import TableColumnSms from "./Items/TableColumnSms";
import FilterMenu from "../Layout/FilterMenu";
import TableFilterBox from "../common/TableFilterBox";
import ContentValidation from "../common/ContentValidation";
import PaginationComp from "../Dashboard/items/Pagination";
import ModalSimple from "../Layout/Modals/ModalSimple";

class SmsTemplate extends React.Component {
  constructor() {
    super();
    this.state = {
      page: 1,
      pageCount: 100,
      paramsFilter: "",
      data: {},
      action: "hide",
    };
  }
  componentDidMount() {
    this.props.getSmsItems(this.state.page, this.state.pageCount);
  }
  componentDidUpdate(_, prevState) {
    if (
      prevState.page !== this.state.page ||
      prevState.pageCount !== this.state.pageCount
    ) {
      this.props.getSmsItems(this.state.page, this.state.pageCount);
    }
  }

  onAction = (action, data) => {
    this.setState({
      data: data || {},
      action,
    });
  };
  setPagination = (page) => {
    this.setState({
      page,
    });
  };
  setPageCount = (pageCount) => {
    this.setState({
      pageCount,
      page: 1,
    });
  };

  render() { 
    return (
      <Container
        location={{
          locationName: "Message templates",
          locationUrl: this.props.match.url,
        }}
      >
        <ContentBlock>
          <FilterMenu
            totals={this.props.totals}
            length={this.props.smsItems.length}
            onChangeCountPage={this.setPageCount}
            countPage={this.state.pageCount}
            text2="Message templates"
          />
        </ContentBlock>
        <ContentBlock>
          <TableFilterBox filter={false} add={this.onAction}></TableFilterBox>
          <div>
            <ContentValidation
              loader={this.props.loading_sms}
              array={this.props.smsItems}
              alertId_s="smsAlert-s"
              alertId_e="smsAlert-e"
            >
              <div className="table-responsive">
                <table className="table table-sm table-hover mt-3">
                  <thead>
                    <tr className="text-muted">
                      <th className="text-black">#</th>
                      <th className="text-black">Country</th>
                      <th className="text-black">Title</th>
                      <th className="text-black">Message</th>
                      <th className="text-black">Identifier</th>
                      <th className="text-black">Technorama</th>
                      <th></th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.props.smsItems.map((item, index) => {
                      return (
                        <TableColumnSms
                          key={index}
                          index={index}
                          id={item.id}
                          item={item}
                          onAction={this.onAction}
                          onDelete={this.props.deleteSmsItem}
                        />
                      );
                    })}
                  </tbody>
                </table>
                <PaginationComp
                  setPagination={this.setPagination}
                  page={this.state.page}
                  totals={this.props.totals}
                  pageCount={this.state.pageCount}
                />
              </div>
            </ContentValidation>
          </div>
        </ContentBlock>

        {this.state.action !== "hide" && (
          <ModalSimple
            text={this.state.action === "new" ? "Create a new one" : "Redaguoti"}
            onClose={() => this.onAction("hide")}
            hide={true}
          >
            <SmsEditModal
              action={this.state.action}
              data={this.state.data}
              closeModal={() => this.onAction("hide")}
              postSmsItem={this.props.postSmsItem}
              updateSmsItem={this.props.updateSmsItem}
            />
          </ModalSimple>
        )}
      </Container>
    );
  }
}
const mapStateToProps = (state) => ({
  smsItems: state.sms.smsItems,
  totals: state.sms.totals,
  loading_sms: state.sms.loading_sms,
  errors: state.errors,
});

export default connect(mapStateToProps, {
  getSmsItems,
  postSmsItem,
  deleteSmsItem,
  updateSmsItem,
  clearErrors,
})(SmsTemplate);
